import axios from 'axios';
import HTTP from './http';

const unauthHttp = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
});

export default {
  getStatus() {
    return unauthHttp.get('/api/v1/Maintenance/Status');
  },
  updateStatus(data) {
    return HTTP.post('/api/v1/Maintenance/Status', data);
  }
};
